<template>
<div>
  <div  v-if="this.selectedSinleStore != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken in salon <strong>{{this.selectedSinleStore.UserName}}</strong> <br> {{getSalonAdres (this.selectedSinleStore.Location)}}<br></div></div>
  </div>

  <div class="row" style="margin-bottom:10px;" v-if="!isChild" ><h1>Maak je keuze en kies een menu</h1></div>
  <div class="shop-product-wrap grid row">
      <template v-for="cat in categories">
        <category-item :category= "cat"></category-item>
      </template>
  </div>
  <div class="shop-product-wrap grid row">
          <template v-if="isChild">
            <div class="row col-24" style="margin-bottom:10px"><h2>{{getCatName ()}} menu</h2></div>
          </template>
          <template v-for="product in products">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-24"><product-item-lst-view :product= "product"></product-item-lst-view></div>
          </template>
          <template v-if="products.length > 0">
              <div v-if="isShowPrices()" style="margin-bottom:20px;margin-top:15px">Ter info: De prijzen kunnen eventueel gewijzigd worden op basis van soort, de duur en de complexiteit van de dienst. Probeer dus zo correct mogelijk de juiste dienst uit te kiezen.</div>
          </template>
   </div>
</div>
</template>

<script>
import Vue from 'vue';
import CategoryItem from './CategoryItem.vue';
import ProductItem from '../products/ProductItem.vue'
import ProductItemLstView from '../products/ProductItemLstView.vue'

  export default {
    name: 'category-list',
    props: ['categories', 'products'],
    created () {
       
    },
    data () {
      return {
        product : {},
        cat : {},
        isChild : false,
        catName : '',
        showPrices : false,
        selectedSinleStore : undefined
      }
    },
    mounted() {
       if (Vue.$storeSettings.IsStoreClosed)
        {
          this.$router.push({ path: '/storeclosed' })
          return;
        }
       this.selectedSinleStore = Vue.$selectedStore;
    },
    computed: {
      
    },
    methods: {
       navBack () {
         this.$router.go (-1);
       },
       getCatName () {
          return Vue.$currCatName;
       },
       isShowPrices () {
         return !Vue.$storeSettings.IsHidePrice;
       },
       getSalonAdres (locationname) {
         var arr = locationname.split (",");
         if (arr.length > 1) return arr[1];
         return locationname;
      }
    },
    components: {
      'category-item': CategoryItem,
      'product-item': ProductItem,
      'product-item-lst-view': ProductItemLstView
    },
    watch: {
      '$route' (to, from) {
         var id = this.$route.params['id'];
         this.isChild = false;
         if (id != undefined)
         {
             this.isChild = true;
         }
      }
    },
    
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/categories/CategoryList.vue